import React from 'react'
import {Route} from 'react-router'
import Success from "./Success";
import Fail from "./Fail";

export default (
    <Route path="/payment">
      <Route path="success" component={Success} />
      <Route path="fail" component={Fail} />
    </Route>
  )
  


// WEBPACK FOOTER //
// ./src/App/Pages/Payment/index.js